/* eslint-disable prettier/prettier */
/**
 * AUTOGENERATED - DO NOT EDIT DIRECTLY
 *
 * Please see "scripts/regionalization/README.md" for how to modify
 */

import { LANGUAGES, REGIONS } from 'state/intl/types';

export const regionSupportedLanguages = {
  [REGIONS.AQ]: new Set([
    LANGUAGES.en,
    LANGUAGES.es,
    LANGUAGES.fr,
    LANGUAGES.de,
    LANGUAGES.it,
  ]),
  [REGIONS.AT]: new Set([
    LANGUAGES.de,
    LANGUAGES.en,
  ]),
  [REGIONS.CA]: new Set([
    LANGUAGES.en,
    LANGUAGES.fr,
  ]),
  [REGIONS.CH]: new Set([
    LANGUAGES.en,
    LANGUAGES.de,
    LANGUAGES.fr,
    LANGUAGES.it,
  ]),
  [REGIONS.CH]: new Set([
    LANGUAGES.en,
    LANGUAGES.de,
    LANGUAGES.fr,
    LANGUAGES.it,
  ]),
  [REGIONS.CZ]: new Set([
    LANGUAGES.cs,
    LANGUAGES.en,
  ]),
  [REGIONS.DE]: new Set([
    LANGUAGES.de,
    LANGUAGES.en,
  ]),
  [REGIONS.ES]: new Set([
    LANGUAGES.es,
    LANGUAGES.ca,
    LANGUAGES.gl,
    LANGUAGES.eu,
    LANGUAGES.en,
  ]),
  [REGIONS.GB]: new Set([
    LANGUAGES.en,
  ]),
  [REGIONS.GB]: new Set([
    LANGUAGES.en,
  ]),
  [REGIONS.NL]: new Set([
    LANGUAGES.nl,
    LANGUAGES.en,
  ]),
  [REGIONS.NZ]: new Set([
    LANGUAGES.en,
  ]),
  [REGIONS.PL]: new Set([
    LANGUAGES.pl,
    LANGUAGES.en,
  ]),
  [REGIONS.PT]: new Set([
    LANGUAGES.pt,
    LANGUAGES.en,
  ]),
  [REGIONS.RO]: new Set([
    LANGUAGES.ro,
    LANGUAGES.en,
  ]),
  [REGIONS.US]: new Set([
    LANGUAGES.en,
  ]),
  [REGIONS.ZA]: new Set([
    LANGUAGES.en,
  ]),
  [REGIONS.ZA]: new Set([
    LANGUAGES.en,
  ]),
};
